export type Tomo = {
  id: string
  emoji: string
  title: string
  subtitle: string
  description: string
  highlight: string
}

export type Bono = {
  number: string
  title: string
  description: string
  price: string
}

export type Testimonial = {
  initials: string
  name: string
  meta: string
  quote: string
}

export type FaqItem = {
  question: string
  answer: string
}

export type ComparisonRow = {
  situation: string
  without: string
  with: string
}

export type CostComparisonRow = {
  without: string
  with: string
}

export const tomos: Tomo[] = [
  {
    id: 'T1',
    emoji: '🖊️',
    title: 'Tomo 1 — Pre-escritura',
    subtitle: 'Manos que Trazan',
    description:
      'Postura, agarre, trazos rectos, curvos, espirales, laberintos y motricidad fina.',
    highlight: 'El punto de partida correcto para cada niño/a — sin saltear pasos.',
  },
  {
    id: 'T2',
    emoji: '✏️',
    title: 'Tomo 2 — Las Vocales',
    subtitle: 'El Universo de la A, E, I, O, U',
    description:
      'Reconocimiento, trazo, sonido y vocabulario 100% argentino de cada vocal.',
    highlight: 'Palabras que el niño/a ya conoce y puede ver.',
  },
  {
    id: 'T3',
    emoji: '🔡',
    title: 'Tomo 3 — Consonantes',
    subtitle: 'Paso a Paso',
    description:
      'Las 9 consonantes fundamentales con silabario completo y primeras palabras.',
    highlight: 'Sin apuros. Con la secuencia que funciona.',
  },
  {
    id: 'T4',
    emoji: '📖',
    title: 'Tomo 4 — Sílabas',
    subtitle: 'y Primeras Palabras',
    description:
      'Silabario completo, palabras de 2 y 3 sílabas, primeras oraciones y dictado.',
    highlight: 'El momento en que empieza a leer — con el andamiaje correcto.',
  },
  {
    id: 'T5',
    emoji: '📝',
    title: 'Tomo 5 — Comprensión Lectora',
    subtitle: 'y Oraciones',
    description:
      'Textos narrativos argentinos, preguntas de comprensión, escritura propia y ortografía básica.',
    highlight: 'Leer con entender. Escribir con intención.',
  },
  {
    id: 'T6',
    emoji: '✍️',
    title: 'Tomo 6 — Caligrafía Cursiva',
    subtitle: 'Argentina',
    description:
      'Trazos base, vocales, consonantes, palabras, frases y primera carta en cursiva.',
    highlight: 'El cierre del ciclo. El logro que se ve y se guarda.',
  },
]

export const tomoIncludes: string[] = [
  'Actividades fotocopiables listas para imprimir',
  'Secuencia de trazos con flechas y puntos de inicio',
  'Vocabulario 100% argentino (mate, asado, hornero, pampa, potrero)',
  'Diplomas imprimibles al terminar cada tomo',
  'Registro de progreso con tabla de seguimiento',
  'Guía para adultos — sabés qué hacer, cómo corregir y qué viene después',
  '100% alineado al nivel inicial y primer ciclo argentino',
]

export const bonos: Bono[] = [
  {
    number: '01',
    title: 'Guía de Inicio Rápido: Primeros 7 Días Sin Estrés',
    description:
      'Empezá el MegaPack en 10 minutos y sabé exactamente qué hacer la primera semana. Sin dudar. Sin improvisar. Con el camino claro desde el día uno.',
    price: '$8.000',
  },
  {
    number: '02',
    title: 'Planificador Semanal de Lectoescritura',
    description:
      '8 semanas de organización para casa y aula sin improvisar. Sabés qué trabajar cada día — y cuánto tiempo lleva.',
    price: '$10.000',
  },
  {
    number: '03',
    title: 'Tracker de Progreso "Mi Camino de Lector"',
    description:
      'Registro visual que convierte cada avance en una victoria que el niño/a puede ver y tocar. Cuando el progreso se ve, las ganas de seguir no se apagan.',
    price: '$9.000',
  },
  {
    number: '04',
    title: 'Kit de Juegos Relámpago',
    description:
      '30 juegos de 5 minutos para practicar letras, sílabas y palabras sin que parezca tarea. Aprendizaje real. Sin resistencia.',
    price: '$8.000',
  },
  {
    number: '05',
    title: 'Guía de Corrección Amable',
    description:
      'Cómo señalar errores de escritura y lectura sin frustrar ni apagar las ganas de aprender. El cambio más rápido que vas a ver — en el niño/a y en vos.',
    price: '$9.000',
  },
  {
    number: '06',
    title: 'Pack de Mini Certificados y Celebraciones de Logros',
    description:
      '20 tarjetas de logro + medallas + certificados semanales + Gran Diploma Final de serie. Porque cada paso merece ser celebrado.',
    price: '$9.000',
  },
]

export const painPoints: string[] = [
  'Actividades de internet en español neutro o mexicano — nada que resuene con un chico argentino',
  'Fichas sin secuencia pedagógica — hoy vocales, mañana cursiva, sin saber si el niño/a está listo',
  'Grupos de WhatsApp llenos de recursos sueltos que nunca forman un camino completo',
  'Material de librería sin guía para el adulto — imprimís y rezás',
  'Grupos con distintos niveles y sin material diferenciado — trabajás al promedio y perdés a todos',
  'Domingo agotado, el lunes llegás con material que "más o menos sirve"',
]

export const topTestimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    meta: 'Córdoba',
    quote:
      'Organicé todo el proceso de mi hija en una tarde. El registro de progreso me ahorra horas cada semana y ella pide practicar sola.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    meta: 'Rosario · Docente de Primaria',
    quote:
      'La cursiva por fin se entiende. Los módulos con secuencia de trazos son el hit de mi aula de primer grado.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    meta: 'Buenos Aires · Psicopedagogo',
    quote:
      'Mis alumnos de apoyo por fin avanzan con un sistema. El Tomo 5 de comprensión lectora vale cada peso.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    meta: 'Neuquén · Papá de Valentina',
    quote:
      'La Guía de Corrección Amable fue un antes y un después. Dejé de pelearme con mi hija en cada sesión.',
  },
]

export const kitTestimonials: Testimonial[] = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    meta: 'Mendoza · MegaPack + Kit Inclusión',
    quote:
      'El sistema de 3 versiones me salvó la vida. Ya no armo dos materiales distintos. Mi alumno con dislexia por fin participa igual que todos.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    meta: 'Buenos Aires · Psicopedagogo',
    quote:
      'Con el juego del tren de sílabas, en 10 minutos el grupo entero estaba leyendo palabras sin vergüenza ni presión.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    meta: 'La Plata · Docente de primer grado',
    quote:
      'Mis alumnos de primer grado terminaron el año leyendo oraciones completas. Eso no pasaba con el material anterior.',
  },
]

export const kitComparison: ComparisonRow[] = [
  {
    situation: 'El niño/a no puede hacer la actividad estándar',
    without: 'Improvisás en el momento',
    with: 'Versión BÁSICA lista en 30 segundos',
  },
  {
    situation: 'Necesitan evaluación diferenciada',
    without: 'La armás el domingo a la noche',
    with: 'Actividad diferenciada. Ya está.',
  },
  {
    situation: 'Dirección pide registro de adecuaciones',
    without: 'Buscás algo que no encontrás',
    with: 'Plantilla firmada. Profesional.',
  },
  {
    situation: 'Alumno/a con dislexia no puede leer el material',
    without: 'Dictás o simplificás',
    with: 'Ficha simplificada. Ya hecha.',
  },
  {
    situation: 'Distintos niveles en el mismo grupo',
    without: 'Perdés a todos',
    with: 'Protocolo de aula abierta. Todos avanzan.',
  },
  {
    situation: 'Poca tolerancia a la frustración',
    without: 'Termina llorando o negándose',
    with: 'Protocolo de 3 minutos. Sale siempre.',
  },
]

export const kitIncludes: string[] = [
  'Sistema de 3 versiones por actividad (básica · estándar · avanzada)',
  'Fichas de lectura simplificada',
  'Actividades diferenciadas listas para usar',
  'Guía para NEE y dificultades de aprendizaje',
  'Protocolo de aula abierta para niveles mixtos',
  'Banco de actividades de ritmo lento',
  'Tarjetas visuales de apoyo',
]

export const faqItems: FaqItem[] = [
  {
    question: '¿Sirve para todos los niveles?',
    answer:
      'Sí. El MegaPack cubre desde los 4 años (pre-escritura y motricidad fina, Tomo 1) hasta los 9-10 años (cursiva avanzada, Tomo 6). El test de nivel incluido en el Bono 1 te dice exactamente por dónde empezar.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      '100% digital. PDF listo para descargar e imprimir. Acceso inmediato después del pago — en menos de 5 minutos estás adentro.',
  },
  {
    question: '¿Qué lo diferencia del material gratuito que encuentro online?',
    answer:
      'El material gratuito no está secuenciado, no tiene guía para el adulto, no está adaptado al español rioplatense y no forma un sistema. Esto sí. Es la diferencia entre fichas sueltas y un camino completo.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      '7 días completos. Si no es lo que esperabas, te devolvemos el 100% del dinero — sin formularios, sin demoras, sin drama.',
  },
]

export const costComparison: CostComparisonRow[] = [
  {
    without: '3 hs de búsqueda × 40 semanas = 120 horas de tu vida por año',
    with: 'Material listo. Abrís, imprimís, usás.',
  },
  {
    without: 'Fichas sin solucionario ni guía',
    with: 'Guía para adultos en cada tomo.',
  },
  {
    without: 'Vocabulario extranjero que no resuena',
    with: '100% vocabulario rioplatense.',
  },
  {
    without: 'Material para NEE inventado en el momento',
    with: '3 versiones por actividad. Ya hechas.',
  },
  {
    without: 'El avance existe pero nadie lo ve',
    with: 'Tracker visual que el niño/a puede tocar.',
  },
  {
    without: 'El mismo ciclo de búsqueda el próximo año',
    with: 'Un sistema que dura todo el año — y el siguiente.',
  },
]

export const purchaseNotices: { name: string; product: string; minutes: number }[] = [
  { name: 'Florencia B. de La Plata', product: 'MegaPack + Kit Inclusión 🏆', minutes: 9 },
  { name: 'Diego S. de Rosario', product: 'MegaPack Caligrafía y Lectoescritura 📘', minutes: 14 },
  { name: 'Carla V. de Salta', product: 'MegaPack + Kit Inclusión 🏆', minutes: 21 },
  { name: 'Verónica T. de Mar del Plata', product: 'MegaPack Caligrafía y Lectoescritura 📘', minutes: 27 },
]

export const CHECKOUT_MEGAPACK =
  'https://www.novarecursos.online/cart/45090138194128:1'

export const CHECKOUT_MEGAPACK_KIT =
  'https://www.novarecursos.online/cart/45090384216272:1'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/94159581-ae08-4a7f-8e60-97f4fa1825c3.jpg'
